// Enumerated values of experience payload fields.

export const statusTypes = {
  DRAFT: "draft",
  PUBLISH: "publish",
  DEMO: "demo",
};

export const clusterTypes = {
  NONE: "none",
  EXPERIENCE: "experience",
  TIMELINE: "timeline",
};

export const experienceTypes = {
  CTA: "cta",
  FAVORITES: "wishlist",
  CHECKLIST: "checklist",
  RECIPE: "recipe",
};

export const articleTypes = {
  UNKNOWN: "unknown",
  PIXMOTO_PRODUCT: "pixmoto-product",
  PRODUCT_REFERENCE: "reference",
};

export const integrationTypes = {
  UNKNOWN: "unknown",
  CODE: "vimeo",
  TOKEN: "shopify",
  BIG_COMMERCE: "big-commerce",
  MAGENTO: "magento",
  SHOPPABLE: "shoppable",
  WHISK: "whisk",
  MYXX: "myxx",
};

export const whiskTypes = {
  LINK: "link",
  MODAL: "modal",
};
